import BaseComponent from "../base-component.js";
import {h} from "preact"
import EssayAnnotationEditor from "./essay-annotation-editor.jsx";
import EssayEditorComponent from "../essay-editor.jsx";
import rubricReport from "../reports/rubric-report.jsx";
import FeedbackContainer from "../reports/feedback-container.jsx";

class EssayQuestionComponent extends BaseComponent {
  responseCollector() {
    var value = this.props.studentResponse?.essay?.response || "";

    if(this.props.mode == "teacher-facing" || this.props.mode == "student-facing-report") {
      if(value == "") {
        return this.omittedPlaceholder();
      }
      return (
        <EssayAnnotationEditor
          response={value}
          teacherResponse={this.props.teacherResponse}
          teacherResponseDidChange={this.props.teacherResponseDidChange}
          teacherResponseDidFinishEdit={this.props.teacherResponseDidFinishEdit}
          readOnly={this.props.mode == "student-facing-report"}
          />
      )
    } else {
      if(this.props.readOnly) {
        return h("div", {class: "response-collector"},
          h("div", {
            class: "essay-response",
            style: "border: solid 1px gray; white-space: pre-line;",
            dangerouslySetInnerHTML: {__html: value}
          })
        );
      } else {
        return <div class="response-collector">
          <EssayEditorComponent
            content={value}
            editorType={this.props.item.responseDeclaration.meta?.editor_type || "none"}
            showEquationEditorButton={this.props.item.responseType == "equation"}
            updateContent={(content) => {
              this.props.updateStudentResponse({
                essay: {
                  response: content
                }
              })
            }}
            />
          </div>
      }
    }
  }

  render() {
    return(
      this.wrapper(
        this.body(),
        this.responseCollector(),
        this.props.teacherResponse?.text_feedback ? <FeedbackContainer feedbackText={this.props.teacherResponse.text_feedback}/> : null,
        this.props.rubricReport && this.props.mode == "student-facing-report" ? rubricReport({rubricReport: this.props.rubricReport}) : null,
      )
    );
  }
}

export default EssayQuestionComponent
